// saboteurData.jsx — 35 perguntas Likert (1-5), contextualizadas para carreira digital
// Distribuição: Juiz(4), Perfeccionista(4), Prestativo(3), Hiper-Realizador(4),
// Vítima(3), Hiper-Racional(3), Hiper-Vigilante(4), Inquieto(3), Controlador(4), Esquivo(3)

export const LIKERT_OPTIONS = [
  { value: 1, label: "Discordo totalmente" },
  { value: 2, label: "Discordo" },
  { value: 3, label: "Neutro" },
  { value: 4, label: "Concordo" },
  { value: 5, label: "Concordo totalmente" },
];

export const QUESTIONS = [
  // ── Juiz (4) ──
  { id: "sab_01", text: "Quando algo dá errado no trabalho, meu primeiro pensamento é identificar de quem foi a culpa.", saboteur: "juiz" },
  { id: "sab_02", text: "Costumo me criticar duramente quando não atinjo o resultado esperado em uma tarefa.", saboteur: "juiz" },
  { id: "sab_03", text: "Frequentemente penso que as pessoas ao meu redor não se esforçam o suficiente.", saboteur: "juiz" },
  { id: "sab_04", text: "Tenho dificuldade em comemorar conquistas porque logo penso no que faltou.", saboteur: "juiz" },

  // ── Perfeccionista (4) ──
  { id: "sab_05", text: "Frequentemente adio a publicação de um projeto porque sinto que ainda não está no nível ideal.", saboteur: "perfeccionista" },
  { id: "sab_06", text: "Retrabalho tarefas várias vezes mesmo quando o resultado já está bom.", saboteur: "perfeccionista" },
  { id: "sab_07", text: "Fico incomodado(a) quando colegas entregam algo que considero abaixo do padrão.", saboteur: "perfeccionista" },
  { id: "sab_08", text: "Prefiro não mostrar meu portfólio até ter certeza de que está impecável.", saboteur: "perfeccionista" },

  // ── Prestativo (3) ──
  { id: "sab_09", text: "Aceito tarefas extras no trabalho mesmo quando já estou sobrecarregado(a), por medo de desagradar.", saboteur: "prestativo" },
  { id: "sab_10", text: "Tenho dificuldade em cobrar por meus serviços o valor que realmente merecem.", saboteur: "prestativo" },
  { id: "sab_11", text: "Costumo priorizar os projetos dos outros antes dos meus próprios.", saboteur: "prestativo" },

  // ── Hiper-Realizador (4) ──
  { id: "sab_12", text: "Minha autoestima depende diretamente das minhas conquistas profissionais recentes.", saboteur: "hiper_realizador" },
  { id: "sab_13", text: "Quando termino um projeto, já estou pensando no próximo sem parar para comemorar.", saboteur: "hiper_realizador" },
  { id: "sab_14", text: "Sinto que preciso estar sempre produzindo algo para me sentir valioso(a).", saboteur: "hiper_realizador" },
  { id: "sab_15", text: "Comparo constantemente meus resultados com os de outros profissionais da minha área.", saboteur: "hiper_realizador" },

  // ── Vítima (3) ──
  { id: "sab_16", text: "Sinto que o mercado digital é injusto e favorece quem já tem contatos ou privilégios.", saboteur: "vitima" },
  { id: "sab_17", text: "Quando não sou selecionado(a) para uma vaga, penso que nunca vou conseguir.", saboteur: "vitima" },
  { id: "sab_18", text: "Acredito que outros profissionais têm mais sorte ou oportunidades do que eu.", saboteur: "vitima" },

  // ── Hiper-Racional (3) ──
  { id: "sab_19", text: "Nas entrevistas, tenho dificuldade em falar sobre sentimentos e motivações pessoais.", saboteur: "hiper_racional" },
  { id: "sab_20", text: "Tomo decisões de carreira puramente por lógica, ignorando o que sinto sobre cada opção.", saboteur: "hiper_racional" },
  { id: "sab_21", text: "Colegas já comentaram que sou uma pessoa difícil de conhecer emocionalmente.", saboteur: "hiper_racional" },

  // ── Hiper-Vigilante (4) ──
  { id: "sab_22", text: "Antes de me candidatar a uma vaga, preciso ter certeza de que cumpro todos os requisitos listados.", saboteur: "hiper_vigilante" },
  { id: "sab_23", text: "Demoro para tomar decisões de carreira porque fico antecipando tudo que pode dar errado.", saboteur: "hiper_vigilante" },
  { id: "sab_24", text: "Leio e releio um e-mail ou mensagem profissional várias vezes antes de enviar.", saboteur: "hiper_vigilante" },
  { id: "sab_25", text: "Tenho dificuldade em confiar em novas oportunidades porque parecem boas demais.", saboteur: "hiper_vigilante" },

  // ── Inquieto (3) ──
  { id: "sab_26", text: "Sempre que descubro uma nova área do digital, penso em mudar completamente de direção.", saboteur: "inquieto" },
  { id: "sab_27", text: "Tenho dificuldade em terminar trilhas de aprendizado porque algo novo sempre me atrai mais.", saboteur: "inquieto" },
  { id: "sab_28", text: "Fico entediado(a) rapidamente em projetos de longo prazo.", saboteur: "inquieto" },

  // ── Controlador (4) ──
  { id: "sab_29", text: "Tenho dificuldade em delegar tarefas porque sinto que ninguém fará do jeito certo.", saboteur: "controlador" },
  { id: "sab_30", text: "Fico frustrado(a) quando processos seletivos não seguem o cronograma que eu esperava.", saboteur: "controlador" },
  { id: "sab_31", text: "Em trabalhos em equipe, costumo assumir a liderança mesmo quando não me pedem.", saboteur: "controlador" },
  { id: "sab_32", text: "Quando algo foge do meu controle no trabalho, fico visivelmente irritado(a).", saboteur: "controlador" },

  // ── Esquivo (3) ──
  { id: "sab_33", text: "Prefiro evitar negociar salário para não criar uma situação desconfortável.", saboteur: "esquivo" },
  { id: "sab_34", text: "Costumo adiar conversas difíceis com gestores ou clientes.", saboteur: "esquivo" },
  { id: "sab_35", text: "Escolho tarefas mais agradáveis e empurro as desconfortáveis para depois.", saboteur: "esquivo" },
];
